export const formatDuration = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const formattedHours = String(hours).padStart(1, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const spendTime = ({ startTime, endTime }) => {
  if (!startTime) return "";
  const startLocalTime = new Date(startTime);
  const endLocalTime = endTime ? new Date(endTime) : new Date();

  const startLocalTimeValue = startLocalTime.getTime();
  const endLocalTimeValue = endLocalTime.getTime();

  const differenceInMilliseconds = endLocalTimeValue - startLocalTimeValue;

  const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);

  return formatDuration(differenceInSeconds);
};
